import createReducer from 'utils/createReducer';
import { SHOW_LOADING_SPINNER } from 'state/actionTypes';

export default createReducer(false, {
  [SHOW_LOADING_SPINNER]: (state, { payload }) => payload,
});
